import React from 'react';
import styled from 'styled-components';
import Chip from './Chip';
import Tabs from 'features/Inventories/interfaces/Tabs';
import {InventoryState} from 'features/Inventories/reducer/InventoryReducer';

const StyledFilterChipContainer = styled.div`
  padding: 8px 0 12px 0;
  display: none;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  max-width: calc(100vw - 48px);
  &.selected {
    display: flex;
  }
  &.hide-geo-chips .chip-geo {
    display: none;
  }

  @media screen and (min-width: 600px) {
    max-width: calc(100vw - 210px - 48px);
  }
`;

const isAFilterSelected = (selectedFilters: string[]) => {
  return selectedFilters.length > 0;
};

interface FilterChipProps {
  invState: InventoryState;
  selectedTab: Tabs;
  handleFilterChange: (value: string[], category: string) => void;
}

function FilterChip({invState, selectedTab, handleFilterChange}: FilterChipProps) {
  const {
    brand,
    geo,
    siteType,
    nvsnso,
    storeConcept,
    siteStatus,
    deviceType,
  } = invState.filterParams;

  const isAnyChipSelected =
    isAFilterSelected(geo) ||
    isAFilterSelected(brand) ||
    isAFilterSelected(siteType) ||
    isAFilterSelected(nvsnso) ||
    isAFilterSelected(storeConcept) ||
    isAFilterSelected(siteStatus) ||
    isAFilterSelected(deviceType);

  const hasSelectedFilters = isAnyChipSelected ? 'selected' : '';

  const isGeoTabSelected = selectedTab !== Tabs.CUSTOM ? 'hide-geo-chips' : '';

  return (
    <StyledFilterChipContainer className={`${hasSelectedFilters} ${isGeoTabSelected}`}>
      <Chip
        key={'brand'}
        label={'Brand'}
        category={'brand'}
        selectedFilters={brand}
        handleFilterChange={handleFilterChange}
        className={`chip-brand`}
      />
      <Chip
        key={'geo'}
        label={'GEO'}
        category={'geo'}
        selectedFilters={geo}
        handleFilterChange={handleFilterChange}
        className={`chip-geo`}
      />
      <Chip
        key={'siteType'}
        label={'Site Type'}
        category={'siteType'}
        selectedFilters={siteType}
        handleFilterChange={handleFilterChange}
        className={`chip-siteType`}
      />
      <Chip
        key={'nvsnso'}
        label={'NVS/NSO'}
        category={'nvsnso'}
        selectedFilters={nvsnso}
        handleFilterChange={handleFilterChange}
        className={`chip-nvsnso`}
      />
      <Chip
        key={'storeConcept'}
        label={'Concept'}
        category={'storeConcept'}
        selectedFilters={storeConcept}
        handleFilterChange={handleFilterChange}
        className={`chip-storeConcept`}
      />
      <Chip
        key={'status'}
        label={'Site Status'}
        category={'siteStatus'}
        selectedFilters={siteStatus}
        handleFilterChange={handleFilterChange}
        className={`chip-siteStatus`}
      />
      <Chip
        key={'deviceType'}
        label={'Device Type'}
        category={'deviceType'}
        selectedFilters={deviceType}
        handleFilterChange={handleFilterChange}
        className={`chip-deviceType`}
      />
    </StyledFilterChipContainer>
  );
}

export default FilterChip;
